import React from 'react'
import { connect } from "react-redux"
import Header from '../layout/Header/Header'
import SideNav from '../layout/Sidebar/SideNav'

// App shell: fixed left navigation + top header + page content
const Layout = ({
    children
}) => {
    return (
      <div className="App bl-shell">
        <Header></Header>
        <SideNav />
        <main id="main-content" tabIndex="-1" className="bl-main">
            {children}
        </main>
      </div>
    )
}

const mapStateToProps = () => {
    return {
    }
  }

  const mapDispatchToProps = {
  }

export default connect(mapStateToProps, mapDispatchToProps)(Layout)
